import { render, staticRenderFns } from "./internal_notes.vue?vue&type=template&id=0e05cadc&"
import script from "./internal_notes.vue?vue&type=script&lang=js&"
export * from "./internal_notes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports